import React, { useEffect } from 'react';
const CookiePolicy = () => {
    useEffect(() => {
        document.title = "Cookie Policy - CGES.CLUB";
    }, []);
    return (
        <>

            <div className="breadcrumb-area policy-breadcrumb">
                <div className="container">
                    <div className="breadcrumb-inner">
                        <h2 className="page-title policy-page-title">Cookie <span>Policy</span></h2>
                        <ul className="page-list">
                            {/* <li><a href="index.html">Home</a></li> */}
                            <li className="policy-effective-date">EFFECTIVE DEC 30, 2024</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="blog-area pd-top-60 policy-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-details-page-content">
                                <div className="single-blog-inner style-large">

                                    <div className="details p-0 policy-content">

                                        <p>This website uses cookies. We use cookies to personalize content and ads, to provide social media features and to analyze our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services. </p>

                                        <br />
                                        <h4 className="title">WHAT ARE COOKIES? </h4>
                                        <p>Cookies are tiny text files that are stored on the browser, hard drive of your computer or mobile device when you visit a webpage or application, to improve your experience. Unless you have adjusted the settings of your browser to refuse cookies, our system will send a cookie to your device when you visit our website.</p>

                                        <br />
                                        <h4 className="title">Necessary Cookies: </h4>
                                        <p>Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies. </p>

                                        <br />
                                        <h4 className="title">Preference Cookies:</h4>
                                        <p>Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in. </p>

                                        <br />
                                        <h4 className="title">Statistics Cookies: </h4>
                                        <p>Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously. </p>

                                        <br />
                                        <h4 className="title">Marketing Cookies: </h4>
                                        <p>Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third-party advertisers.</p>

                                        <br />
                                        <h4 className="title">Disabling Cookies: </h4>
                                        <p>You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our website. </p>

                                        <br />
                                        <p>If you have any questions or inquiries, please contact: <br />

                                            <a href='mailto:support@cges.club' className = 'color-base'>Email: info@cges.club </a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CookiePolicy
